<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import ButtonLink from '../UI/Button/ButtonLink.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import { ACTOR_TYPE_LESSOR } from '../../Constants/ActorType'

export default {
  components: { ButtonAll, ButtonLink, BlockContent },
  props: {
    documentSign: {
      type: Object,
      required: true,
    },
    eSign: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    title() {
      switch (this.signer.signType) {
        case ACTOR_TYPE_LESSOR:
          return 'contract.document.signing.company.title'

        default:
          return 'contract.document.sign'
      }
    },
    instructions() {
      switch (this.signer.signType) {
        case ACTOR_TYPE_LESSOR:
          if (this.eSign) {
            return ['contract.document.signing.company.esign.instruction']
          } else {
            return [
              'contract.document.signing.company.manual.instructions.download',
              'contract.document.signing.company.manual.instructions.upload',
            ]
          }
        default:
          if (this.eSign) {
            return ['contract.document.autoSign']
          } else {
            return ['contract.document.manualSign']
          }
      }
    },
    signed() {
      return ['SIGNED', 'SIGNED_FULL'].includes(this.documentSign.status) && this.documentSign.signedAt !== null
    },
    signedText() {
      if (!this.documentSign.signedAt) {
        return null
      }

      const signedAt = new Date(this.documentSign.signedAt)

      return this.$t('contract.document.signing.done', {
        date: this.$d(signedAt, 'date'),
        firstName: this.signer.firstname,
        lastName: this.signer.lastname,
      })
    },
    signer() {
      return this.documentSign.documentSigner
    },
    buttons() {
      return {
        eSign: this.eSign === true,
        email: this.eSign === true,
        download: this.eSign === false,
      }
    },
    eSignUrl() {
      return `/sign/${this.signer.id}/?token=${this.signer.token}`
    },
  },
}
</script>
<template>
  <BlockContent :title-t="title" e2e-block="contractDocumentSignature">
    <div class="bg-pale-secondary b-1 border-light p-20">
      <template v-if="signed">
        <div class="font-weight-bold text-center">{{ signedText }}</div>
      </template>
      <template v-else>
        <div class="font-weight-bold text-center" v-for="(instruction, index) of instructions" :key="index">
          {{ $t(instruction) }}
        </div>
        <div class="col-12 text-center mt-2">
          <ButtonLink
            v-if="buttons.eSign"
            label="contract.document.signNow"
            type="outline_success"
            size="large"
            :href="eSignUrl"
            external
            name="goToSign"
          />
          <ButtonAll
            v-if="buttons.email"
            label="contract.document.sendMail"
            type="outline_info"
            size="large"
            @click="$emit('email')"
            name="contractSendSigningEmail"
          />
          <ButtonAll
            v-if="buttons.download"
            label="contract.document.signNow"
            type="danger"
            size="large"
            @click="$emit('download')"
            name="contractDownload"
          />
        </div>
      </template>
    </div>
  </BlockContent>
</template>
